export class TweetBuilder {
  constructor(message, options = {}) {
    this.options = {
      separator: ' ',
      maxTweetLength: 280,
      urlLength: 23,
      ...options,
    };

    this.characterCount = {
      urls: 0,
      mentions: 0,
      hashtags: 0,
    };

    this.message = message;
  }

  build(urls, mentions, hashtags) {
    let supplementString = [
      this.urls(urls, this.options.separator),
      this.mentions(mentions, `${this.options.separator}@`),
      this.hashtags(hashtags, `${this.options.separator}#`),
    ].join('');

    let supplementLength = this.characterCount.urls + this.characterCount.mentions + this.characterCount.hashtags;

    if (supplementLength >= this.options.maxTweetLength) {
      supplementString = '';
      supplementLength = 0;
    }

    return (this.content(this.message, supplementLength) + supplementString).trim();
  }

  /**
   * @access private
   */
  content(content, supplementLength) {
    const appendEllipsis = ((content.length + supplementLength) > this.options.maxTweetLength);
    const charactersToRetain = this.options.maxTweetLength - supplementLength - 1;

    return appendEllipsis ? `${content.substring(0, charactersToRetain)}…` : content;
  }

  /**
   * @access private
   */
  urls(urls, prefix) {
    if (!urls) {
      return '';
    }

    const urlsArray = urls.split(this.options.separator);
    this.characterCount.urls = urlsArray.length * (this.options.urlLength + this.options.separator.length);

    return prefix + urlsArray.join(prefix);
  }

  /**
   * @access private
   */
  mentions(mentions, prefix) {
    if (!mentions) {
      return '';
    }

    const mentionsString = prefix + mentions.split(this.options.separator).join(prefix);
    this.characterCount.mentions = mentionsString.length;

    return mentionsString;
  }

  /**
   * @access private
   */
  hashtags(hashtags, prefix) {
    if (!hashtags) {
      return '';
    }

    const hashtagsString = prefix + hashtags.split(this.options.separator).join(prefix);
    this.characterCount.hashtags = hashtagsString.length;

    return hashtagsString;
  }
}
